import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';
import { AdsVehicleGroupService } from './vehicle-group.service';
import { VehicleGroup } from '../model/vehicle-group';

@Injectable()
export class VehicleGroupsProvider {

  private groupsSubject = new BehaviorSubject<VehicleGroup[] | null>(null);
  nonNullGroups$ = this.groupsSubject.asObservable().pipe(filter(groups => groups != null), first());
  groupsWithUpdates$ = this.groupsSubject.asObservable().pipe(map(groups => groups == null ? [] : groups));

  constructor(private vehicleGroupService: AdsVehicleGroupService) {
    this.loadData().subscribe();
  }

  loadData(): Observable<any> {
    return this.vehicleGroupService.getVehicleGroups().pipe(tap(groups => this.setVehicleGroups(groups)));
  }

  private setVehicleGroups(groups: VehicleGroup[]): void {
    this.groupsSubject.next(groups);
  }

}
